import { getDepartments, getUsers } from 'lib/api';
import { USER_ACTIONS } from './userReducer';
import { GlobalAction } from '.';

const {
  GET_USERS_START,
  GET_USERS_ERROR,
  GET_USERS_SUCCESS,
  GET_DEPARTMENTS_START,
  GET_DEPARTMENTS_ERROR,
  GET_DEPARTMENTS_SUCCESS,
} = USER_ACTIONS;

type LoadUsersParams = {
  params: any;
  customerId: any;
  dispatch: React.Dispatch<GlobalAction>;
};

export const loadUsers = async ({
  params,
  customerId,
  dispatch,
}: LoadUsersParams): Promise<void> => {
  dispatch({ type: GET_USERS_START });
  const response = await getUsers(customerId, params).catch(err => err);
  if (response instanceof Error) {
    dispatch({
      type: GET_USERS_ERROR,
      error: response.message,
    });
    return;
  }

  dispatch({
    type: GET_USERS_SUCCESS,
    payload: {
      users: { items: response.userList || [] },
      count: parseInt(response.totalCount, 10),
      totalAllowedUsers: parseInt(response.totalAllowedUsers, 10),
      totalActiveUsers: parseInt(response.totalActiveUsers, 10),
    },
  });
};

export const loadDepartments = async ({
  params,
  customerId,
  dispatch,
}: LoadUsersParams): Promise<void> => {
  dispatch({ type: GET_DEPARTMENTS_START });
  const response = await getDepartments(customerId, params).catch(err => err);
  if (response instanceof Error) {
    dispatch({
      type: GET_DEPARTMENTS_ERROR,
      error: response.message,
    });
    return;
  }

  dispatch({
    type: GET_DEPARTMENTS_SUCCESS,
    payload: {
      departments: { items: response.data || [] },
      count: parseInt(response.data.length, 10),
    },
  });
};
